import { render, staticRenderFns } from "./leftmenueventos.vue?vue&type=template&id=6ddb6136&"
import script from "./leftmenueventos.vue?vue&type=script&lang=js&"
export * from "./leftmenueventos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports